import layout from '@/layout'

export default {
  path: '/info',
  component: layout,
  redirect: '/info/order',
  name: 'info_order',
  meta: {
    title: 'info',
    icon: 'info'
  },
  children: [
    {
      path: '/info/order',
      name: 'info_order',
      component: () => import('@/views/info/order/index'),
      meta: {
        title: 'info_order',
        icon: 'info'
      }
    }
  ]
}
